import categoryPageStateManager from '../category_page_state_manager';
import loadable from '@loadable/component';

const NewsPage = loadable(() => import('../news_page'));

export default function(store) {
  return {
    path: '/news/:page?',
    component: NewsPage,
    strict: true,
    exact: true,
    loadData: categoryPageStateManager(store, 'news')
  };
}
